import React from "react";
import {ReactCompareSlider} from "react-compare-slider";
import {GatsbyImage} from "gatsby-plugin-image";

const ImageComparison = (
  {
    className = "",
    itemOneImageData = null,
    itemTwoImageData = null,
    generalImage = null,
  }
  ) => {
  return (
    <section className={`image-comparison ${className}`}>
      {itemOneImageData && itemTwoImageData ? (
        <ReactCompareSlider
          itemOne={
            <GatsbyImage
              image={itemOneImageData}
              alt="Evo"
            />
          }
          itemTwo={
            <GatsbyImage
              image={itemTwoImageData}
              alt="Evo"
            />
          }
        />
      ) : (
        <GatsbyImage
          image={generalImage}
          alt="Evo"
        />
      )}
    </section>
  )
}

export default ImageComparison
